import React, { useRef } from 'react';
import Title from '../../atoms/title/title.js';
import Icon from '../../atoms/icon/icon.js';

const getClassName = (title, type, dynemicHeight) => {
    let className = title ? `mbw-button-${type}` : `mbw-button-${type} mbw-button-no-title`;
    className = dynemicHeight ? className + " mbw-button-dynemic-height" : className;
    return className;
};
const Button = ({ title, type = "primary", icon, onClick, disabled = false, dynemicHeight = false }) => {
    const buttonRef = useRef(null);
    const renderIcon = () => (icon ? (React.createElement("div", { "data-testid": "mbw-button-icon", className: "mbw-button--button-icon-container" },
        React.createElement(Icon, { parentRef: buttonRef, className: "mbw-button--button-icon" }, icon))) : null);
    const renderTitle = () => title ? (React.createElement("div", { "data-testid": "mbw-button-title", className: "mbw-button--center-text" },
        React.createElement(Title, { fontStyle: "content-default", bold: true }, title))) : null;
    return (React.createElement("button", { "data-testid": "mbw-button", ref: buttonRef, className: getClassName(title, type, dynemicHeight), onClick: onClick, disabled: disabled },
        React.createElement("div", { className: "mbw-button--center" },
            renderIcon(),
            renderTitle())));
};

export { Button as default };
//# sourceMappingURL=button.js.map
